module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_A_2.5ce520b2.mp3";